import { WHITELABEL_THEME_ASSET_CSS_PROPERTIES } from './theme-asset-css-vars';
import { THEME_ASSET_NAMES, THEME_ASSET_REGISTRY } from './build-theme-asset-registry';
import { DEFAULT_THEME_ID, type ThemeId } from '../types/theme';

export { THEME_ASSET_NAMES };

export function getThemeAssetUrl(themeId: ThemeId, assetName: string): string {
  const url =
    THEME_ASSET_REGISTRY[themeId]?.[assetName] ??
    THEME_ASSET_REGISTRY[DEFAULT_THEME_ID]?.[assetName];

  if (!url) {
    throw new Error(
      `[theme] Asset "${assetName}" is missing for theme "${themeId}" and default "${DEFAULT_THEME_ID}".`,
    );
  }

  return url;
}

export function applyThemeAssetCssVars(
  themeId: ThemeId,
  properties: Record<string, string>,
): void {
  const root = document.documentElement;

  for (const [assetName, cssProperty] of Object.entries(properties)) {
    const url = getThemeAssetUrl(themeId, assetName);
    root.style.setProperty(cssProperty, `url("${url}")`);
  }
}

export function applyWhitelabelThemeAssetCssVars(themeId: ThemeId): void {
  if (Object.keys(WHITELABEL_THEME_ASSET_CSS_PROPERTIES).length === 0) {
    return;
  }

  applyThemeAssetCssVars(themeId, WHITELABEL_THEME_ASSET_CSS_PROPERTIES);
}

export function clearWhitelabelThemeAssetCssVars(): void {
  const root = document.documentElement;

  for (const cssProperty of Object.values(WHITELABEL_THEME_ASSET_CSS_PROPERTIES)) {
    root.style.removeProperty(cssProperty);
  }
}
